/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicJiraChangeManagementHandler extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicJiraChangeManagementHandler");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicJiraChangeManagementHandler>): BackgroundJobPayloadForPeriodicJiraChangeManagementHandler {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicJiraChangeManagementHandler(), model);
        BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicJiraChangeManagementHandler>): BackgroundJobPayloadForPeriodicJiraChangeManagementHandler {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.newInstance(<BackgroundJobPayloadForPeriodicJiraChangeManagementHandler> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicJiraChangeManagementHandler) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicJiraChangeManagementHandler): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
